// extracted by mini-css-extract-plugin
module.exports = {"IpStructured":"STstyle_IpStructured__iGNu7","CompareTabsStructured":"STstyle_CompareTabsStructured__eDamP"};